module.exports = __webpack_public_path__ + "static/media/arrow-left.075f1171.svg";